import { Slot } from "@radix-ui/react-slot";
import type { ImgHTMLAttributes } from "react";

import { cn } from "../utils/cn";

interface IconMastercardProps extends ImgHTMLAttributes<HTMLImageElement> {
  asChild?: boolean;
}

function IconMastercard({ className, asChild = false }: IconMastercardProps) {
  const Comp = asChild ? Slot : "svg";
  return (
    <Comp
      className={cn(className)}
      fill="none"
      height="38"
      viewBox="0 0 68 38"
      width="68"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect height="38" width="67.7623" />
      <path
        d="M40.8822 6.42627H26.8853V31.5807H40.8822V6.42627Z"
        fill="#FF5F00"
      />
      <path
        d="M27.7738 19.0013C27.7694 14.0912 30.0222 9.45671 33.8836 6.42627C26.9384 0.965256 16.8829 2.16943 11.4219 9.11901C5.96086 16.0641 7.16504 26.1197 14.1146 31.5807C19.9178 36.1397 28.0849 36.1397 33.8836 31.5807C30.0222 28.5503 27.7694 23.9113 27.7738 19.0057V19.0013Z"
        fill="#EB001B"
      />
      <path
        d="M59.7624 19.0013C59.7624 27.8349 52.5996 34.9978 43.766 34.9978C40.1801 34.9978 36.7009 33.7936 33.8793 31.5763C40.8244 26.1153 42.0286 16.0553 36.5676 9.11017C35.7811 8.11039 34.8791 7.20837 33.8793 6.42188C40.8244 0.960862 50.88 2.16504 56.341 9.11461C58.5583 11.9318 59.7624 15.4154 59.7624 19.0013Z"
        fill="#F79E1B"
      />
      <path
        d="M58.2383 28.9147V28.3992H58.4471V28.2926H57.9183V28.3992H58.1272V28.9147H58.2427H58.2383ZM59.2647 28.9147V28.2926H59.1047L58.9181 28.7192L58.7315 28.2926H58.5715V28.9147H58.6871V28.4481L58.8604 28.8525H58.9803L59.1536 28.4481V28.9191H59.2692L59.2647 28.9147Z"
        fill="#F79E1B"
      />
    </Comp>
  );
}

IconMastercard.displayName = "IconMastercard";

export { IconMastercard };
